import moment from 'moment';
// Required for moment.tz() below - without it this module depends on another one importing it first.
import 'moment-timezone';
import { AccountData, OrderingCutoffStrategy, OrderPageData } from '../../../../api';

export const isAfterCutoffTimeInAccountTimezone = (account?: AccountData, hour = 18, minute = 0): boolean => {
  if (!account) {
    return false;
  }
  const now = moment.tz(account.timezone);
  const cutoffTime = moment.tz(account.timezone).set({ hour, minute, second: 0, millisecond: 0 });
  return now.isAfter(cutoffTime);
};

export const isTimeSlotBookable = (
  timeSlotSeconds: number,
  selectedDate: string,
  orderPage: OrderPageData,
  account?: AccountData,
): boolean => {
  // in multiple pages there is no order page provided so we dont limited
  if (!orderPage) {
    return true;
  }
  const cutoffSettings = orderPage.ordering_cutoff_settings;

  // If no cutoff settings, use legacy behavior (already handled in getMinDateBasedOnCutoffSettings)
  if (!cutoffSettings || cutoffSettings.strategy !== OrderingCutoffStrategy.HOURS_BEFORE_START) {
    return true;
  }

  // For HOURS_BEFORE_START strategy, check individual time slots
  if (cutoffSettings.strategy === OrderingCutoffStrategy.HOURS_BEFORE_START && cutoffSettings.hours_before_start) {
    const timezone = account?.timezone || 'UTC';

    // Create the workshop datetime by combining the selected date with the time slot
    // timeSlotSeconds is seconds from midnight in the correct timezone
    const workshopDateTime = moment.tz(selectedDate, timezone).startOf('day').add(timeSlotSeconds, 'seconds');

    // Get current time in the account's timezone
    const now = moment.tz(timezone);

    // Calculate the cutoff time: workshop time minus the required hours before start
    const cutoffDateTime = workshopDateTime.clone().subtract(cutoffSettings.hours_before_start, 'hours');

    // The time slot is bookable if we're still before the cutoff time
    return now.isBefore(cutoffDateTime);
  }

  return true;
};
